export default __webpack_public_path__ + "static/media/NOFS_pumpkin.9e0b87ab.gif";